import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge<'text-size' | 'button-color' | 'button-style' | 'button-variant'>({
    extend: {
        classGroups: {
            'text-size': [
                'text-xs',
                'text-sm',
                'text-base',
                'text-lg',
                'text-xl',
                'text-2xl',
                'text-3xl',
                'text-4xl',
                'text-5xl',
                'text-6xl',
                'text-7xl',
                'text-8xl',
                'text-9xl',
                'text-size-prominent-xl',
                'text-size-prominent-l',
                'text-size-prominent',
                'text-size-h1',
                'text-size-h2',
                'text-size-h3',
                'text-size-h4',
                'text-size-h5',
                'text-size-h6',
                'text-size-paragraph-heavy',
                'text-size-paragraph',
                'text-size-caption-heavy',
                'text-size-caption',
            ],
            'button-color': ['btn-primary', 'btn-secondary'],
            'button-style': ['btn-standard', 'btn-inverse'],
            'button-variant': ['btn-solid', 'btn-outline'],
        },
    },
});
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
